export default __webpack_public_path__ + "static/typography-image-t-ebc6db88bf48db5fecf2b87cfea9a10d04e89dd3e7f7267dacf8523de224ed02.png";